import { render, staticRenderFns } from "./PPaginationBase.vue?vue&type=template&id=232a254d&scoped=true&"
import script from "./PPaginationBase.vue?vue&type=script&lang=js&"
export * from "./PPaginationBase.vue?vue&type=script&lang=js&"
import style0 from "./PPaginationBase.vue?vue&type=style&index=0&id=232a254d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a254d",
  null
  
)

export default component.exports